import { combineReducers } from '@reduxjs/toolkit';
import complaintAppComplaint from './complaint/reducers';
import complaintTypeReducer from './complaintType/reducer';
import appDetailsReducer from './appDetails/reducer';
import { rolesSlice } from './Roles/reducer';
import WorkflowReducer from './Workflow/reducer';
import queryManagement from './querymanagement/reducers';

const rootReducer = combineReducers({
  complaintAppComplaint,
  complaintType: complaintTypeReducer,
  appDetails: appDetailsReducer,
  workflow: WorkflowReducer,
  roles: rolesSlice.reducer,
  queryManagement,
});

export default rootReducer;
